import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { GET_RADIODENSITY_MEASUREMENTS_BY_DIGITAL_TWIN_ID } from "../../queries/radiodensityMeasurementQueries";

export function useRadiodensityMeasurements(digitalTwinId) {
  const { data, loading, error, refetch } = useQuery(
    GET_RADIODENSITY_MEASUREMENTS_BY_DIGITAL_TWIN_ID,
    {
      variables: { digital_twin_id: digitalTwinId },
      skip: !digitalTwinId,
      fetchPolicy: "network-only",
    }
  );

  const radiodensityMeasurements = useMemo(() => {
    return data?.radiodensityMeasurementsByDigitalTwinId || [];
  }, [data]);

  // Organize measurements by vertebra ID for easy lookup
  const measurementsByVertebra = useMemo(() => {
    const byVertebra = {};
    radiodensityMeasurements.forEach(measurement => {
      byVertebra[measurement.vertebra] = measurement;
    });
    return byVertebra;
  }, [radiodensityMeasurements]);

  return {
    radiodensityMeasurements,
    measurementsByVertebra,
    loading,
    error,
    refetch,
  };
}
